import React, { useEffect, useRef, useState } from 'react';
import * as authentication from './authentication';

export default function AccountForm({ initialMode = 'login', onClose, onSignedIn }) {
  const [mode, setMode] = useState(initialMode);
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);
  const dialog = useRef(null);

  useEffect(() => {
    const element = dialog.current;
    const previousFocus = document.activeElement;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    element.showModal();
    element.querySelector('input')?.focus();
    return () => {
      element.close();
      document.body.style.overflow = overflow;
      if (previousFocus?.isConnected) previousFocus.focus();
    };
  }, []);

  const titles = { login: 'Log in', register: 'Create account' };

  async function submit(event) {
    event.preventDefault();
    const fields = new FormData(event.currentTarget);
    setBusy(true);
    setMessage('');
    try {
      await authentication[mode](fields.get('email'), fields.get('password'));
      onSignedIn();
    } catch (error) {
      setMessage(error.message || 'Unable to connect. Your meditation progress is still on this device.');
    } finally {
      setBusy(false);
    }
  }

  return <dialog ref={dialog} className="card account" aria-labelledby="account-title"
    onCancel={event => { event.preventDefault(); onClose(); }}>
    <button type="button" className="btn btn-link top-right" onClick={onClose}>Close</button>
    <h2 id="account-title">{titles[mode]}</h2>
    <p>An account is optional. Use it to save your progress across devices.</p>
    <form onSubmit={submit}>
      <label>Email
        <input name="email" type="email" autoComplete="email" maxLength={254} required />
      </label>
      <label>Password
        <input name="password" type="password" autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
          minLength={mode === 'login' ? undefined : 12} maxLength={72} required />
        {mode !== 'login' && <small>At least 12 characters (up to 72 bytes).</small>}
      </label>
      {message && <p role="status">{message}</p>}
      <button className="btn btn-primary" disabled={busy}>{busy ? 'Please wait…' : titles[mode]}</button>
    </form>
    <div className="account-links">
      {['login', 'register'].filter(item => item !== mode).map(item =>
        <button type="button" key={item} className="btn btn-link" disabled={busy}
          onClick={() => { setMode(item); setMessage(''); }}>{titles[item]}</button>)}
    </div>
    {mode === 'login' && <p className="small">Forgot your password? <a href="mailto:blog@aaron.com.es?subject=Voidhead%20account%20recovery">Contact Aarón for help</a> from your account's email address. Recovery is handled personally.</p>}
    <p className="small">By creating an account you agree to the <a href="/tos.html">terms</a> and acknowledge the <a href="/privacy.html">privacy notice</a>.</p>
  </dialog>;
}
